import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { pmTicketSignalLevelsFormConfig } from "../../constants/pmTicketSignalLevelsFormConfig";
import { pmTicketSignalLevelFieldValidator } from "../../utils/signalLevelFieldValidator";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import PmTicketSignalLevelsForm from "../signal-levels/PmTicketSignalLevelsForm";


class PmTicketSignalLevels extends React.Component {
    constructor(props) {
        super(props);

        this.handleValueValidation = this
            .handleValueValidation
            .bind(this);
        this.handleCheckStateChange = this
            .handleCheckStateChange
            .bind(this);
        this.handleTextValueChange = this
            .handleTextValueChange
            .bind(this);
    }

    handleValueValidation(value, action) {
        const configs = pmTicketSignalLevelsFormConfig;

        return pmTicketSignalLevelFieldValidator(configs, value, action);
    }

    handleCheckStateChange(e, value, action) {
        const { workOrderActions, orderId, orderCloseDetails } = this.props;

        const existingTicket = orderCloseDetails
            .getIn(['closeOrderRequest', 'ticketRequests'])
            .find((item) => {
                return item.get('workType') === "Maintenance";
            });

        const signalLevels = this.updateSignalLevels(existingTicket, value, action);

        if (existingTicket) {
            workOrderActions.ticketRequestAdd({
                workType: "Maintenance",
                customerImpacting: existingTicket.get('customerImpacting'),
                comment: existingTicket.get('comment'),
                pmTicketSignalLevel: signalLevels
            }, orderId);
        }
    }

    updateSignalLevels(existingTicket, value, action) {
        if (existingTicket) {
            const signalLevels = existingTicket.get('pmTicketSignalLevel');
            if (signalLevels) {
                return {
                    ...signalLevels,
                    [action]: value
                };
            }
            return {
                [action]: value
            };
        }
        return null;
    }

    handleTextValueChange(value, id) {
        const { workOrderActions, orderId, orderCloseDetails } = this.props;
        const errors = this.handleValueValidation(value, id);


        const existingTicket = orderCloseDetails
            .getIn(['closeOrderRequest', 'ticketRequests'])
            .find((item) => {
                return item.get('workType') === "Maintenance";
            });

        const signalLevels = this.updateSignalLevels(existingTicket, value, id);

        if (existingTicket) {
            workOrderActions.ticketRequestAdd({
                workType: "Maintenance",
                customerImpacting: existingTicket.get('customerImpacting'),
                comment: existingTicket.get('comment'),
                pmTicketSignalLevel: signalLevels
            }, orderId);

            workOrderActions.setFstSignalValue({
                action: id,
                errors: errors.errors,
                errorMessage: errors.errorMessage,
                errorLocation: "pmTicketSignalLevelsDetails",
                storeLocation: "pmTicketSignalLevel"
            }, orderId);
        }

    }

    getDropdownOptionsList() {
        return [
            {
                value: 'Yes',
                label: 'Yes'
            }, {
                value: 'No',
                label: 'No'
            }];
    }

    render() {
        const { orderCloseDetails, existingTicket } = this.props;
        const dropdownOptions = this.getDropdownOptionsList().map((item, index) => {
            return (<MenuItem
                key={`post_ber_issue_${index}`}
                value={item.value}
                primaryText={item.label} />);
        });

        const configs = pmTicketSignalLevelsFormConfig.fields;
        const signalLevelsDetails = orderCloseDetails.getIn(['pmTicketSignalLevelsDetails']);
        const signalLevelsStore = existingTicket ? Immutable.fromJS(existingTicket.get("pmTicketSignalLevel")) : null;
        const postBerSelectedValue = existingTicket && existingTicket.get("pmTicketSignalLevel") ?
            existingTicket.get("pmTicketSignalLevel").postBerIssue : null;

        return (<div style={{ marginBottom: "8px" }}>
            <label>Signal Levels:</label>
            <PmTicketSignalLevelsForm
                handleValueChange={this.handleTextValueChange}
                configs={configs}
                signalLevelsStore={signalLevelsStore}
                signalLevelsDetails={signalLevelsDetails}
            />
            <div style={{ margin: "4px" }}>
                <label>Post BER issues present?</label>
                <SelectField
                    floatingLabelText="Select option"
                    style={{ width: "100%" }}
                    value={postBerSelectedValue}
                    onChange={(e, _, val) => this.handleCheckStateChange(e, val, 'postBerIssue')}>
                    {dropdownOptions}
                </SelectField>
            </div>
        </div>
        )
    }
}

PmTicketSignalLevels.propTypes = {
    workOrderActions: PropTypes.object,
    techId: PropTypes.string,
    index: PropTypes.number,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    stepConfig: PropTypes.object,
};

export default PmTicketSignalLevels;



// WEBPACK FOOTER //
// ./src/components/ticket/pmTicketSignalLevels.js